<template>
  <div>
    <div class="" v-if="disabled">
      <div class="disabled-red" v-if="this.disponibility.end === null">
        Não configurado
      </div>
      <div class="disabled-green" v-else>
        De {{ disponibility.start | time }} até {{ disponibility.end | time }} - {{ disponibility.capacity }} por período
      </div>
    </div>
    <v-dialog v-model="timeScheduleModal" persistent scrollable full-width max-width='450' v-else>
    <div class="link-red" slot="activator" v-if="this.disponibility.end === null">
      Não configurado
    </div>
    <div class="link-green" slot="activator" v-else>
      De {{ disponibility.start | time }} até {{ disponibility.end | time }} - {{ disponibility.capacity }} por período
    </div>
    <v-card class="pl-5 pr-5 no-details">
      <v-card-title class="pa-0 pt-4 pb-3">
        <v-flex>
          <h6>
            Capacidade de atendimento
          </h6>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn class="ma-0" icon @click="timeScheduleModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <hr>
        </v-flex>
      </v-card-title>
      <v-card class="mb-2 elevation-0">
        <v-layout row wrap>
          <v-flex xs12 class="tilte-time-schedule">
            Horário Comercial
          </v-flex>
          <v-flex xs12>
            <p>
              Informe qual o horário que trabalhará:
            </p>
          </v-flex>
          <v-flex style="width:140px;">
            <v-select
            :items="startSelect"
            :value="disponibilityStart"
            @input="updateDisponibilityStart"
            prepend-icon="access_time"
            single-line
            hide-details
            >
            <template slot="selection" slot-scope="data">
              <div class="input-group__selections__comma" :key="JSON.stringify(data.item)">{{ data.item | time }}</div>
            </template>
            <template slot="item" slot-scope="data">
              <div class="">
                {{ data.item | time }}
              </div>
            </template>
          </v-select>
          </v-flex>
          <v-flex class="text-xs-center time-separator">
            até
          </v-flex>
          <v-flex style="width:140px;">
            <v-select
            :items="endSelect"
            :value="disponibilityEnd"
            @input="updateDisponibilityEnd"
            :disabled="disponibility.start === null"
            prepend-icon="access_time"
            single-line
            hide-details
            >
            <template slot="selection" slot-scope="data">
              <div class="input-group__selections__comma" :key="JSON.stringify(data.item)">{{ data.item | time }}</div>
            </template>
            <template slot="item" slot-scope="data">
              <div class="">
                {{ data.item | time }}
              </div>
            </template>
          </v-select>
          </v-flex>
          <v-flex xs12 mt-3 mb-3>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 class="tilte-time-schedule">
            Tempo médio de realização do serviço
          </v-flex>
          <v-flex xs12>
            <p>
              Agora, qual é o tempo médio de realização deste serviço:
            </p>
          </v-flex>
          <v-flex>            
          <v-menu
            ref="menuInterval"
            :close-on-content-click="false"
            v-model="toggleMenuInterval"
            :nudge-right="40"
            :return-value.sync="disponibilityInterval"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"            
            >
            <v-text-field
              slot="activator"
              :value="disponibility.interval"              
              prepend-icon="access_time"
              v-model="disponibilityInterval"
              :class="{'error-input': errorDisponibilityInterval}"
              readonly              
            ></v-text-field>
            <v-time-picker
              :allowed-minutes="allowedMinutes"
              v-model="disponibilityInterval"
              color="red" 
              format="24hr" 
              @change="$refs.menuInterval.save(disponibilityInterval)">
            </v-time-picker>
          </v-menu>          
            <!-- <v-time-picker :value="disponibility.interval" format="24hr"></v-time-picker> -->
          </v-flex>
          <v-flex xs12 mt-3 mb-3>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 class="tilte-time-schedule">
            Atendimento(s) Simultâneo(s)
          </v-flex>
          <v-flex xs12>
            <p>
              Quantos atendimentos simultâneos você poderá realizar no período acima:
            </p>
          </v-flex>
          <v-flex>
            <v-select
            :items="capacitySelect"
            :value="disponibility.capacity"
            @input="updateCapacity"
            single-line
            prepend-icon="people"
            hide-details
            :nudge-top="10"
            >
              <template slot="selection" slot-scope="data">
                <div class="input-group__selections__comma" :key="JSON.stringify(data.item)">{{ data.item }} atendimento<span v-show="data.item > 1">s</span></div>
              </template>
              <template slot="item" slot-scope="data">
                <div class="">
                  {{ data.item }}
                </div>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center mt-2">
            <v-btn color="green darken-1" flat="flat" @click="timeScheduleModal = false">Aplicar</v-btn>
          </v-flex>
        </v-layout>
      </v-card>    
  </v-card>
</v-dialog>

  </div>
</template>


<script>
import moment from 'moment'
import interval from './interval'

export default {
  name: 'time-schedule',
  data () {
    return {
      intervalSelect: interval,
      toggleMenuInterval: false
    }
  },
  methods: {
    updateCapacity (value) {
      this.$store.commit('updateCapacity', value)
    },
    updateInterval (value) {
      this.$store.commit('updateInterval', value)
    },
    updateDisponibilityStart (value) {
      this.$store.commit('updateDisponibilityStart', value)
    },
    updateDisponibilityEnd (value) {
      this.$store.commit('updateDisponibilityEnd', value)
    },
    diffMinuteDisponibility () {
      return [0, 15, 30, 45]
    },
    allowedMinutes (value) {
      return value % 15 === 0
    }
  },
  computed: {
    schedule () {
      return this.$store.getters.selectedSchedule
    },
    disabled () {
      return this.schedule.status > 0 && (this.schedule.sent || !this.$store.getters.scheduleEditing) || (!this.$store.getters.scheduleEditing && this.schedule.id !== '')
    },
    disponibility () {
      return this.schedule.disponibility
    },
    capacitySelect () {
      return [...Array(50)].map((elem, index) => index + 1)
    },
    startSelect () {
      let interval = 0.5
      let x = 24 / interval
      return [...Array(x)].map((elem, index) => {
        let time = index * interval
        return time <= 1 ? moment('2013-01-01T00:00:00').add(time, 'hours').format('HH:mm:ss') : moment('2013-01-01T00:00:00').add(time, 'hours').format('HH:mm:ss')
      })
    },
    endSelect () {
      return this.disponibility.start === null ? [] : this.startSelect.slice(this.startSelect.findIndex(elem => elem === this.disponibility.start) + 1, this.startSelect.length)
    },
    timeScheduleModal: {
      get () {
        return this.$store.getters.timeScheduleModal
      },
      set (value) {
        this.step = 1
        this.$store.commit('toggleTimeScheduleModal', value)
      }
    },
    disponibilityInterval: {
      get () {
        return this.$store.getters.disponibilityInterval
      },
      set (value) {
        this.$store.commit('updateInterval', value)
      }
    },
    disponibilityStart () {
      if (!this.$store.getters.disponibilityStart) {
        this.updateDisponibilityStart('09:00:00')
      }
      return this.$store.getters.disponibilityStart
    },
    disponibilityEnd () {
      if (!this.$store.getters.disponibilityEnd) {
        this.updateDisponibilityEnd('18:00:00')
      }
      return this.$store.getters.disponibilityEnd
    },
    errorDisponibilityInterval () {
      return this.$store.getters.errorDisponibilityInterval
    }
  },
  filters: {
    time (value) {
      return moment('2013-01-01T' + value).format('HH:mm')
    }
  }
}
</script>
<style>
.tilte-time-schedule{
  font-size: 18px;
  color: #4a4a4a;
}
/* ajustes */
.label-disponibility{
  font-size: 18px;
  padding: 4px;
}
.condominium-wrapper{
  background-color: #f3f3f3;
  font-size: 16px;
}
.condominium-box{
  border: 2px solid #e4e4e4;
  background-color: #fff;
}
.titulo-detalhes{
    color: #e62039;
    font-size: 21px;
}
.titulo-detalhes .headline{
  font-size: 25px;
}
.titulo-detalhes-categoria{
  font-size: 21px;
  padding-top: 17px;
  color: #707983
}
p{
color: #838789
}
.search-text{
  color:#b1b1b1;
  font-size: 18px;
}
.search-text span{
  color: #e24054;
  font-weight: bold;
}
.no-details .input-group__details{
  display: none!important
}
.no-details .input-group{
  padding: 3px;
  padding-left: 10px;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
}
.link-red, .disabled-red {
  color:red;
}
.link-green, .disabled-green {
  color:green;

}
.disabled-red, .disabled-green{
  cursor: default;
  opacity: 0.7;
}
.link-red:hover, .link-green:hover {
  cursor: pointer;
  opacity: 0.9;
}
.time-separator{
  font-size: 21px;
  padding-top: 3px;
}
.error-input {
  border: 2px solid #e62039!important;  
}
</style>



// WEBPACK FOOTER //
// TimeSchedule.vue?3c5c9f2c